const createApi = {
  method: 'post',
  url: '/v1/subscribe/create'
}

const queryApi = {
  method: 'get',
  url: '/v1/subscribe/getByProjectTypeAndPaged'
}

const deleteApi = {
  method: 'post',
  url: '/v1/subscribe/batchDelete'
}

const updateApi = {
  method: 'post',
  url: '/v1/subscribe/update'
}

export { createApi, queryApi, deleteApi, updateApi }
